import type {
  ElementType,
  FunctionComponent,
  HTMLProps,
  ReactNode,
} from 'react'
import React from 'react'

import classnames from 'classnames'

import { DownloadRoundelIcon } from '../../Icons/Roundel/DownloadRoundel'
import { FacebookRoundelIcon } from '../../Icons/Roundel/FacebookRoundel'
import { InstagramRoundelIcon } from '../../Icons/Roundel/InstagramRoundel'
import { MailRoundelIcon } from '../../Icons/Roundel/MailRoundel'
import { PrintRoundelIcon } from '../../Icons/Roundel/PrintRoundel'
import { WhatsappRoundelIcon } from '../../Icons/Roundel/WhatsappRoundel'
import { XRoundelIcon } from '../../Icons/Roundel/XRoundel'
import { YoutubeRoundelIcon } from '../../Icons/Roundel/YoutubeRoundel'
import { Link } from '../../Link/Link'
import styles from './SocialLink.module.scss'

export const SocialLink: FunctionComponent<SocialLinkProps> = ({
  href,
  children,
  icon,
  className,
  ...rest
}) => {
  const SocialIcon = iconMapper[icon as keyof ElementType]

  return (
    <Link
      href={href}
      icon={SocialIcon}
      includeIcon={true}
      appearance="secondary"
      textStyle="sb-text-interface-body-small-regular"
      checkIsExternal={false}
      includeNoReferrer={true}
      className={classnames(styles.socialLink, className)}
      target="_blank"
      data-testid={`social-link-${icon}`}
      {...rest}
    >
      {children && (
        <span dangerouslySetInnerHTML={{ __html: children as string }} />
      )}
    </Link>
  )
}

///////// IMPLEMENTATION /////////

type SocialLinkProps = {
  href?: string | null
  children?: ReactNode
  className?: string
  icon: SocialIconName
} & HTMLProps<HTMLAnchorElement>

export type SocialIconName =
  | 'facebook'
  | 'instagram'
  | 'whatsapp'
  | 'youtube'
  | 'download'
  | 'mail'
  | 'print'
  | 'twitter'
  | 'x'

export const iconMapper: { [Key in SocialIconName]: ElementType } = {
  facebook: FacebookRoundelIcon,
  instagram: InstagramRoundelIcon,
  whatsapp: WhatsappRoundelIcon,
  youtube: YoutubeRoundelIcon,
  download: DownloadRoundelIcon,
  mail: MailRoundelIcon,
  print: PrintRoundelIcon,
  x: XRoundelIcon,
  twitter: XRoundelIcon,
}
